// extracted by mini-css-extract-plugin
module.exports = {"Desc-Text":"Desc_Desc-Text__Oe2JL"};